import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { MaintenancePriority, MaintenanceStatus, MaintenanceTabType } from '@/models/features'

export interface GetMaintenanceCountsByClientRequest {
  buildingId?: number
  search?: string
  type?: MaintenanceTabType
  status?: MaintenanceStatus[]
  priority?: MaintenancePriority[]
  assigneeId?: number[]
  yardiPropertyId?: string[]
  dateFrom?: number
  dateTo?: number
  limit?: number
  skip?: number
}

interface MaintenanceCountByClient {
  clientId: number
  name: string
  count: number
}

export interface GetMaintenanceCountsByClientResponse {
  data: MaintenanceCountByClient[]
  total: number
  skip: number
  limit: number
  hasMore: boolean
}

export const MAINTENANCE_COUNTS_BY_CLIENT_BASE_QUERY_KEY = 'useGetMaintenanceCountsByClient'

export const getMaintenanceCountsByClientQueryKey = (data: GetMaintenanceCountsByClientRequest) => [
  MAINTENANCE_COUNTS_BY_CLIENT_BASE_QUERY_KEY,
  data,
]

export const getMaintenanceCountsByClient = async (
  params: GetMaintenanceCountsByClientRequest,
  signal?: AbortSignal,
): Promise<GetMaintenanceCountsByClientResponse> => {
  const { buildingId, ...rest } = params
  const response = await authAPI.get<GetMaintenanceCountsByClientResponse>(
    `/v2/maintenance/counts/${buildingId}/client`,
    { params: rest, signal },
  )
  return response.data
}

export const useGetMaintenanceCountsByClient = (data: GetMaintenanceCountsByClientRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    gcTime: 0,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getMaintenanceCountsByClient(data, signal),
    queryKey: getMaintenanceCountsByClientQueryKey(data),
  })
}
